import Filter from '@publicImages/svg/filters.svg?icon';
export default Filter;
